import React, { useEffect, useState } from "react";
import { viewUnitList } from "../../Redux/Actions/unitsActions";
import { useDispatch, useSelector } from "react-redux";
import { columnsUnits } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";

const ListUnits = () => {
  const dispatch = useDispatch();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [searchQuery, setSearchQuery] = useState("");
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchDetails = (page, limit) => {
    const unitData = {
      page,
      limit,
      filter: searchQuery,
    };
    dispatch(viewUnitList(unitData));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, searchQuery]);

  const { units, loading } = useSelector((state) => state.units);

  useEffect(() => {
    if (units?.total) {
      setPagination((prevData) => ({ ...prevData, total: units.total }));
    }
  }, [units]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  return (
    <TableComponent
      h3heading="Furnishing List"
      buttonhead2={canAdd ? "Add Furnishings" : null}
      navigateTo2={canAdd ? "/furnishing/add" : null}
      setState={setSearchQuery}
      columns={columnsUnits(canEdit)}
      dataSource={Array.isArray(units?.data) ? units.data : []}
      rowKey="_id"
      loading={loading}
      onChange={handleTableChange}
      pagination={pagination}
    ></TableComponent>
  );
};

export default ListUnits;
